import { SelectValue } from '../../../Components/Base/Select/Select';
import { WorkplaceType } from '../Enums/WorkplaceType.enum';

export interface WorkplaceFolderValues {
	parentId: SelectValue;
	name: string;
}

export interface WorkplaceNormalValues {
	parentId: SelectValue;
	name: string;
	codeName?: string;
	fieldOfCare?: SelectValue;
	formOfCare?: SelectValue;
	phone?: string;
	address: object; //LOADING DYNAMIC CONTAINER FROM API
	icpNumber?: string;
	iczNumber?: string;
	calendarEmailNotification: boolean;
	memberSearchableOutside: boolean;
	workplaceSearchableOutside: boolean;
	createCaseTarget?: SelectValue;
	onlineOrderTarget?: SelectValue;
	defaultDoctorId?: SelectValue;
	defaultInvitation: boolean;
	role: SelectValue[];
}

export const prepareWorkplaceDataByType = ({
	type,
	values,
}: {
	type: WorkplaceType;
	values: WorkplaceFolderValues | WorkplaceNormalValues;
}) => {
	if (type === WorkplaceType.FOLDER) {
		//HANDLING DATA FOR FOLDER
		const { parentId, ...restOfValues } = values as WorkplaceFolderValues;
		return {
			...restOfValues,
			parentWorkplaceId: parentId.value,
			type,
		};
	} else if (type === WorkplaceType.NORMAL) {
		//HANDLING DATA FOR NORMAL WORKPLACE
		const {
			fieldOfCare,
			formOfCare,
			createCaseTarget,
			onlineOrderTarget,
			icpNumber,
			iczNumber,
			defaultDoctorId,
			parentId,
			role,
			...restOfValues
		} = values as WorkplaceNormalValues;

		const termItems: { id: string }[] = [];
		const meta: { key: string; value: string }[] = [];

		if (fieldOfCare?.value) {
			termItems.push({ id: fieldOfCare.value as string });
		}

		if (formOfCare?.value) {
			termItems.push({ id: formOfCare.value as string });
		}

		if (icpNumber) {
			meta.push({
				key: 'icp',
				value: icpNumber,
			});
		}

		if (iczNumber) {
			meta.push({
				key: 'icz',
				value: iczNumber,
			});
		}

		return {
			...restOfValues,
			termItems,
			meta,
			type,
			roleIds: role.map(item => item.value),
			parentWorkplaceId: parentId.value,
			createCaseTarget: createCaseTarget?.value,
			onlineOrderTarget: onlineOrderTarget?.value,
			defaultDoctorId: defaultDoctorId?.value,
		};
	}
};
